/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';

/**
 * 
 * @export
 * @interface MinervalSearch
 */
export interface MinervalSearch {
    /**
     * 
     * @type {TextSearch}
     * @memberof MinervalSearch
     */
    anneeScolaire?: TextSearch;
    /**
     * 
     * @type {number}
     * @memberof MinervalSearch
     */
    idapprenant?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof MinervalSearch
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof MinervalSearch
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof MinervalSearch
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MinervalSearch
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof MinervalSearch
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof MinervalSearch
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the MinervalSearch interface.
 */
export function instanceOfMinervalSearch(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MinervalSearchFromJSON(json: any): MinervalSearch {
    return MinervalSearchFromJSONTyped(json, false);
}

export function MinervalSearchFromJSONTyped(json: any, ignoreDiscriminator: boolean): MinervalSearch {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'anneeScolaire': !exists(json, 'anneeScolaire') ? undefined : TextSearchFromJSON(json['anneeScolaire']),
        'idapprenant': !exists(json, 'idapprenant') ? undefined : json['idapprenant'],
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function MinervalSearchToJSON(value?: MinervalSearch | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'anneeScolaire': TextSearchToJSON(value.anneeScolaire),
        'idapprenant': value.idapprenant,
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

